module.exports = __webpack_public_path__ + "img/yaguangchoubiandaiWu.min.c62476c2.png";